<div class="container">
  <h2 mat-dialog-title>Save Layout</h2>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="font-medium mb-4 mt-2">How would you like to save the layout?</div>
      <mat-radio-group formControlName="saveMode" color="primary">
        <mat-radio-button value="update" class="mb-2">
          Update existing layout [{{ data.templateName }}]. This will apply to other {{ data.typeLabel }} using this
          layout.
        </mat-radio-button>
        <mat-radio-button value="create" class="mb-4">
          Create a new layout and apply to this {{ data.typeLabel }}.
        </mat-radio-button>
      </mat-radio-group>
      <ng-container>
        <mat-form-field [@slideInOut]="isCreateSaveMode ? 'in' : 'out'">
          <mat-label>What should we call this new template?</mat-label>
          <input matInput placeholder="Template Name" formControlName="templateName" />
        </mat-form-field>
      </ng-container>
    </form>
    <div class="flex justify-end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="save()">Save</button>
    </div>
  </mat-dialog-content>
</div>
